import React from 'react';
import {
  FeedEvent,
  NewPlayPayload,
  NewPlayerPayload,
  NewGamePayload,
  ReactionPayload,
  PlayerPlayMilestonePayload,
  PlayerWinStreakPayload,
  GamePlayMilestonePayload,
  ReactionsResponse
} from '../../generated-api';
import { FeedPlayDetails } from './feedUtils';
import { NewPlayCard } from './event-cards/NewPlayCard';
import { NewPlayerCard } from './event-cards/NewPlayerCard';
import { NewGameCard } from './event-cards/NewGameCard';
import { ReactionCard } from './event-cards/ReactionCard';
import { PlayerPlayMilestoneCard } from './event-cards/PlayerPlayMilestoneCard';
import { PlayerWinStreakCard } from './event-cards/PlayerWinStreakCard';
import { GamePlayMilestoneCard } from './event-cards/GamePlayMilestoneCard';

interface EventCardProps {
  event: FeedEvent;
  reactionsMap?: Record<string, ReactionsResponse>;
  playDetailsMap?: Record<string, FeedPlayDetails>;
}

export const EventCard: React.FC<EventCardProps> = ({ event, reactionsMap = {}, playDetailsMap = {} }) => {
  switch (event.eventType) {
    case 'NEW_PLAY':
      const playPayload = event.payload as NewPlayPayload;
      return (
        <NewPlayCard
          payload={playPayload}
          createdAt={event.createdAt}
          initialReactions={reactionsMap[playPayload.playId]}
          details={playDetailsMap[playPayload.playId]}
        />
      );
    case 'NEW_PLAYER':
      return (
        <NewPlayerCard
          payload={event.payload as NewPlayerPayload}
          createdAt={event.createdAt}
        />
      );
    case 'NEW_GAME':
      return (
        <NewGameCard
          payload={event.payload as NewGamePayload}
          createdAt={event.createdAt}
        />
      );
    case 'REACTION':
      return (
        <ReactionCard
          payload={event.payload as ReactionPayload}
          createdAt={event.createdAt}
        />
      );
    case 'PLAYER_PLAY_MILESTONE':
      return (
        <PlayerPlayMilestoneCard
          payload={event.payload as PlayerPlayMilestonePayload}
          createdAt={event.createdAt}
        />
      );
    case 'PLAYER_WIN_STREAK':
      return (
        <PlayerWinStreakCard
          payload={event.payload as PlayerWinStreakPayload}
          createdAt={event.createdAt}
        />
      );
    case 'GAME_PLAY_MILESTONE':
      return (
        <GamePlayMilestoneCard
          payload={event.payload as GamePlayMilestonePayload}
          createdAt={event.createdAt}
        />
      );
    default:
      console.warn('Unknown event type:', event.eventType);
      return null;
  }
};
